import { render, staticRenderFns } from "./callList.vue?vue&type=template&id=a23e9a8a&scoped=true&"
import script from "./callList.vue?vue&type=script&lang=js&"
export * from "./callList.vue?vue&type=script&lang=js&"
import style0 from "./callList.vue?vue&type=style&index=0&id=a23e9a8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23e9a8a",
  null
  
)

export default component.exports